
import { RANGER_METADATA } from '../../ranger/model/ranger.metadata';
import { AMMUNITION_STOCK_METADATA } from './ammunition-stock.metadata';
import { AmmunitionStockEventType } from './ammunition-stock.types';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AmmunitionStockEventMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('AmmunitionStockEvent', {
      ammunitionStockEventId: <PropertyMetadata> {
        name: 'ammunitionStockEventId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      ammunitionStock: <PropertyMetadata> {
        name: 'ammunitionStock',
        type: 'AmmunitionStock',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return AMMUNITION_STOCK_METADATA;
        },
        byReference: true,
        unique: false
      },
      ranger: <PropertyMetadata> {
        name: 'ranger',
        type: 'Ranger',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return RANGER_METADATA;
        },
        byReference: true,
        unique: false
      },
      acknowledgeTokenExpires: <PropertyMetadata> {
        name: 'acknowledgeTokenExpires',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      acknowledged: <PropertyMetadata> {
        name: 'acknowledged',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      ammunitionStockEventType: <PropertyMetadata> {
        name: 'ammunitionStockEventType',
        type: 'AmmunitionStockEventType',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      dateAcknowledged: <PropertyMetadata> {
        name: 'dateAcknowledged',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      eventDate: <PropertyMetadata> {
        name: 'eventDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      quantity: <PropertyMetadata> {
        name: 'quantity',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.ammunitionStockEventId;
    return nullIfContainsNull(result);
  }
}



